/**
 * Device pixels per CSS pixel on screen. On phones the page is shown at half scale (see index.html),
 * which devicePixelRatio does not include: without it, canvases would be drawn at 4× the pixels shown.
 */
export function devicePixels(): number {
  return (window.devicePixelRatio || 1) * pageScale();
}

/** A phone: the page is shown at half scale only on phones (index.html). */
export function isPhone(): boolean {
  return pageScale() < 1;
}

function pageScale(): number {
  return (window as unknown as { __pageScale?: number }).__pageScale ?? 1;
}
